import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useLegacyApi } from '../../../routes/legacyApiHook';
import LandingPage from '../components/LandingPage';
import LandingpageImage from '../../../mock/landingpageImage';
import { LANDING_PAGE } from '../../../routes/config/pageTypes';
import { RootState } from '../../../config/redux/types';

export default function LandingPageContainer(): JSX.Element | null {
  const landingPage = useSelector((state: RootState) => state.routes.landingPage);
  const { slug } = useParams<'slug'>();

  useLegacyApi([slug], LANDING_PAGE);

  if (!landingPage) {
    return null;
  }

  return (
    <LandingPage
      {...landingPage}
      heroImage={{
        ...landingPage.heroImage,
        image: (LandingpageImage as any)[landingPage.heroImage.slug],
      }}
    />
  );
}
